import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResourceResponse } from "../../types/api/getResources";

export type ResourceState = {
  resources: ResourceResponse[];
  loading: boolean;
};

const initialState: ResourceState = {
  resources: [],
  loading: false,
};

const resource = createSlice({
  name: "resource",
  initialState,
  reducers: {
    clearResource: (state) => {
      state.resources = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setResources: (state, action: PayloadAction<ResourceResponse[]>) => {
      state.resources = action.payload;
      state.loading = false;
    },
    addResource: (state, action: PayloadAction<ResourceResponse>) => {
      state.resources.unshift(action.payload);
    },
    updateResource: (
      state,
      action: PayloadAction<{ id: number; data: ResourceResponse }>
    ) => {
      const index = state.resources.findIndex(
        (resource) => resource.id === action.payload.id
      );
      if (index !== -1) {
        state.resources[index] = action.payload.data;
      }
    },
    deleteResource: (state, action: PayloadAction<number>) => {
      state.resources = state.resources.filter(
        (resource) => resource.id !== action.payload
      );
    },
  },
});

export default resource;
export const {
  clearResource,
  setResources,
  setLoading,
  addResource,
  updateResource,
  deleteResource,
} = resource.actions;
